"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStatesForReactSelect = exports.getFullCountryName = exports.getCountriesWithFlagsForReactSelect = exports.CountriesUtils = void 0;
var _react = _interopRequireDefault(require("react"));
var _constants = require("./constants");
var _lodash = require("lodash");
var _countryListJson = require("country-list-json");
var _usaStates = require("./usaStates.utils");
var _components = require("../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var UsaStates = _usaStates.UsaStatesUtils.UsaStates;
var isMemberInUnitedStates = function isMemberInUnitedStates(memberCountryCode) {
  return memberCountryCode === _constants.US_COUNTRY_CODE;
};
var getFullCountryName = function getFullCountryName(countryCode) {
  var country = (0, _lodash.find)(_countryListJson.countries, function (country) {
    return country.code === countryCode;
  });
  return country === null || country === void 0 ? void 0 : country.name;
};
exports.getFullCountryName = getFullCountryName;
var getCountriesWithFlagsForReactSelect = function getCountriesWithFlagsForReactSelect() {
  return (0, _lodash.map)(_constants.AVAILABLE_COUNTRY_CODES, function (countryCode) {
    var country = (0, _lodash.find)(_countryListJson.countries, function (country) {
      return country.code === countryCode;
    });
    var label = /*#__PURE__*/_react.default.createElement("div", {
      className: "flex flex-row gap-x-[14px] items-center"
    }, /*#__PURE__*/_react.default.createElement(_components.CountryFlag, {
      code: countryCode,
      name: getFullCountryName(countryCode)
    }), /*#__PURE__*/_react.default.createElement("span", null, country.name));
    return {
      value: country.code,
      name: country.name,
      label: label
    };
  });
};
exports.getCountriesWithFlagsForReactSelect = getCountriesWithFlagsForReactSelect;
var getStatesForReactSelect = function getStatesForReactSelect() {
  return (0, _lodash.map)(UsaStates, function (state) {
    return {
      value: state.abbreviation,
      name: state.name,
      label: state.name
    };
  });
};
exports.getStatesForReactSelect = getStatesForReactSelect;
var CountriesUtils = {
  isMemberInUnitedStates: isMemberInUnitedStates,
  getFullCountryName: getFullCountryName
};
exports.CountriesUtils = CountriesUtils;